import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";
import {Project} from "../domain/entities/project.entity";
import {transformer} from "../decorators/transformer.decorator";
import {CreateProjectCommand} from "../commands/create-project.command";
import {TransformerHelper} from "../helpers/transformer.helper";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {injectable} from "tsyringe";

@injectable()
@transformer({
    source: CreateProjectCommand,
    target: `dto`
})
export class CreateProjectCommandToDtoTransformer extends AbstractCommandToDtoTransformer<Project> {

    protected async toDTO(project: Project): Promise<DataTransferObject> {
        return TransformerHelper.toDTO(project);
    }
}